import React from 'react';
import { Chip } from '@mui/material';
import {
  colorChipEstadoChequeTercero,
  etiquetaEstadoChequeTercero,
  resolverEstadoChequeTercero,
  type EstadoChequeTercero,
} from '../../../utils/chequeTerceroEstado';

/** Campos mínimos para resolver estado en listados de cheques devueltos Info360. */
export type ChequeDevueltoEstadoInput = {
  senial?: number | null;
  concepto?: string | null;
  conciliado?: number | null;
  fechaSalida?: string | null;
  nroMovCajaSalida?: number | null;
  comprobanteSalida?: string | null;
  rechazado?: number | null;
};

export function formatInfo360ChequeFecha(value?: string | null): string {
  if (!value) return '—';
  try {
    return new Intl.DateTimeFormat('es-AR', { dateStyle: 'short' }).format(new Date(value));
  } catch {
    return value;
  }
}

export function textoMotivoSeguimiento(concepto?: string | null): string {
  const t = (concepto ?? '').trim();
  return t || '—';
}

/** En este historial los ítems son rechazados; si el payload no trae flag, asumimos rechazado. */
export function resolverEstadoChequeDevueltoInfo360(
  item: ChequeDevueltoEstadoInput
): EstadoChequeTercero {
  return resolverEstadoChequeTercero({
    ...item,
    rechazado: item.rechazado ?? 1,
  });
}

export function ChipEstadoChequeDevuelto({ item }: { item: ChequeDevueltoEstadoInput }) {
  const estado = resolverEstadoChequeDevueltoInfo360(item);
  return (
    <Chip
      label={etiquetaEstadoChequeTercero(estado)}
      color={colorChipEstadoChequeTercero(estado)}
      size="small"
    />
  );
}
